
<div class="d-flex" style=" margin-left: 44px ; margin-bottom: 24px ; margin-top: 24px;">
    <div class=" row align-items-center">
        <div class="input-group form-password-toggle d-flex" style="width: 300px; padding-right: 13px">
            <input
                    type="text"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Search..."
                    aria-describedby="basic-addon-search1"
                    [(ngModel)]="searchTerm" (ngModelChange)="onSearch()"
            />
            <div class="input-group-append" style="margin-right: 10px;">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i
                            data-feather="search" [size]="20"></i></span>
            </div>

        </div>
        <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
            <span data-feather="filter"></span>
        </button>
    </div>
    <!-- Filter Panel -->
    <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 350px;max-height: 450px">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column p-1" style="height: 350px; margin: 8px ;box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14)">
            <div class="flex-grow-1 overflow-auto pe-1">
                <div class="mb-1">
                    <label class="form-label">Client</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1 " [(ngModel)]="filters.operator">
                            <option value="=">Tous</option>
                            <option value=">">Tous</option>
                            <option value="<">Tous</option>
                        </select>

                    </div>
                </div>

                <div class="mb-1">
                    <label class="form-label"> Projet </label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1 " [(ngModel)]="filters.operator">

                            <option value="paiement">Tous</option>
                            <option value="remise_banque">Reçus</option>
                            <option value="operation_diverse">Sortie</option>

                        </select>

                    </div>
                </div>
                <!-- Montant -->
                <div class="mb-1">
                    <label class="form-label">Montant</label>
                    <div class="input-group">
                        <select class="form-control w-25" [(ngModel)]="filters.montant">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control ml-1" [(ngModel)]="filters.price"/>
                    </div>
                </div>
                <div class="mb-3" >
                    <label class="form-label d-block">État</label>
                    <div class="d-flex gap-2 flex-wrap" style="gap: 18px">
                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                [class.active]="filters.etat === ''"
                                (click)="filters.etat = ''">Tous
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                [class.active]="filters.etat === 'cree'"
                                (click)="filters.etat = 'cree'">Créé
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                [class.active]="filters.etat === 'annule'"
                                (click)="filters.etat = 'annule'">Annulé
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm"
                                [class.active]="filters.etat === 'valide'"
                                (click)="filters.etat = 'valide'">Validé
                        </button>
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Point de vente</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control flex-grow-1 " [(ngModel)]="filters.operator">
                            <option value="="></option>
                            <option value=">"></option>

                        </select>

                    </div>
                </div>


            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary " (click)="resetFilters()" style="margin-right: 15px;">Réinitialiser</button>
                <button class="btn btn-primary " (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>




    <div class="col-auto ms-auto" style="margin-left: auto;margin-right: 24px">
        <button type="button" class="btn btn-primary mt-0" (click)="AddBonTransf()"><span data-feather="plus" style="color: white;"></span> Ajouter</button>
    </div>
</div>


<div style=" border-bottom: 1px solid #eee; margin-top: 24px; margin-bottom: 10px"></div>

<div class="table-responsive">
    <table class="table table-hover">
        <thead class="custom-thead">
        <tr  class="align-middle" >
            <th>RÉFÉRENCE</th>
            <th>DATE</th>
            <th>Entrepôt initial</th>
            <th>Entrepôt destination</th>
            <th>STATUT</th>
            <th style="width: 200px">ACTION</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of filteredItems | paginate: { itemsPerPage: perPage, currentPage: currentPage }">

            <td class="ref">{{ item.reference }}</td>
            <td>{{ item.date }}</td>
            <td><span class="size15">  {{ item.clientName }} </span> <br>
                <span class="size13 text-sm-center text-muted"> Layne_Kuvalis@gmail.com </span>
            </td>
            <td><span class="size15 p-0"> {{ item.totalTTC }}</span> <br>
                <span class="size13 text-sm-center text-muted">{{ item.totalTTCNoSpace }}</span>
            </td>

            <td><span class="size13" [ngClass]="getStatusClass(item.status)">  {{ item.status }} </span></td>
            <td>
                <div class="d-flex align-items-center action-icon">
                    <button class="unstyled-btn">
                        <i data-feather="edit" [size]="20" class="cursor-pointer m-2"></i>
                    </button>

                    <button class="unstyled-btn" (click)="openDetailModal(item)">
                        <i data-feather="eye" [size]="20" class="cursor-pointer"></i>
                    </button>
                    <div ngbDropdown container="body">
                        <button class="unstyled-btn "
                                ngbDropdownToggle

                                id="dropdownBrowserState{{item.reference}}">
                            <i data-feather="more-vertical" [size]="20" class="cursor-pointer m-2"></i>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu-right"
                             aria-labelledby="dropdownBrowserState{{item.reference}}">
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="editItem(item); $event.preventDefault()">
                                <span data-feather="file-text" class="mr-50"></span> PDF
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="changeStatus(item); $event.preventDefault()">
                                <span data-feather="phone-call" class="mr-50"></span> Appeler
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="openModal(item, 'etat'); $event.preventDefault()">
                                <span data-feather="message-square" class="mr-50"></span> Envoyer un SMS
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="openModal(item, 'etat'); $event.preventDefault()">
                                <span data-feather="download" class="mr-50"></span> Télécharger
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="sendEmail(item); $event.preventDefault()">
                                <span data-feather="mail" class="mr-50"></span> Envoyer par email
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="openModal(item, 'etat'); $event.preventDefault()">
                                <span data-feather="copy" class="mr-50"></span> Dupliquer
                            </a>
                            <a href="javascript:void(0)" ngbDropdownItem
                               (click)="openModal(item, 'etat'); $event.preventDefault()">
                                <span data-feather="paperclip" class="mr-50"></span> Pièce jointe
                            </a>
                        </div>
                    </div>
                </div>

            </td>
        </tr>
        </tbody>
    </table>
</div>

<div class="d-flex justify-content-between align-items-center my-3">
    <div>
        <label for="perPageSelect" class="form-label me-2">Afficher</label>
        <select id="perPageSelect" [(ngModel)]="perPage" class="custom-select d-inline-block w-auto">
            <option *ngFor="let n of pageOptions" [value]="n">{{ n }}</option>
        </select>
    </div>

    <pagination-controls
            (pageChange)="currentPage = $event"
            [previousLabel]="''"
            [nextLabel]="''"
            class="mb-0"
    ></pagination-controls>

</div>

<app-detail-inventaire #detailInventaire></app-detail-inventaire>
